import { FC } from 'react';
import { Interstitial as LoadingIndicator } from '@interstate/components/Interstitial';
import { CenteredLoadingIndicator } from './LoadingPage.style';

export const LoadingPage: FC<any> = () => (
    <CenteredLoadingIndicator data-testid="loading-indicator">
        <LoadingIndicator size="large" />
    </CenteredLoadingIndicator>
);
